import React from 'react';
import { useLocation } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { Col } from '@amzn/atoz-web/Col';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
import { LocationEligibilityTabs } from './LocationEligibilityTabs';
import { WeeklyHoursSummary } from './WeeklyHoursSummary';
import { NUMBER_OF_WEEKS } from './LocationEligibilityTypes';
import { LocationEligibilityList } from './LocationEligibilityList';
import { useWeekQueryParam, useLocationEligibility } from './hooks';
export var LocationEligibility = function (_a) {
    var currentWeekProgress = _a.currentWeekProgress, siteEligibilitiesPerWeek = _a.siteEligibilitiesPerWeek;
    var t = useTranslation().t;
    var _b = useWeekQueryParam(NUMBER_OF_WEEKS), weekParam = _b.weekParam, setWeekParam = _b.setWeekParam;
    var location = useLocation();
    var fromHome = location.pathname.indexOf('dashboard') >= 0;
    var _c = useLocationEligibility({
        currentWeekProgress: currentWeekProgress,
        siteEligibilitiesPerWeek: siteEligibilitiesPerWeek,
        selectedWeek: weekParam
    }), totalDurationForWeek = _c.totalDurationForWeek, scheduledDurationForWeek = _c.scheduledDurationForWeek, workedDurationForWeek = _c.workedDurationForWeek, siteEligibilitiesForWeek = _c.siteEligibilitiesForWeek;
    return (React.createElement(Col, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Row, { justifyContent: "center", padding: "S300" },
                React.createElement(PageTitle, null, t('shift_management_features_locationEligibility_pageTitle'))),
            React.createElement(View, { dataTestId: "location-eligibility-tabs" },
                React.createElement(LocationEligibilityTabs, { selectedWeek: weekParam, setSelectedWeek: setWeekParam }))),
        React.createElement(View, { dataTestId: "location-eligibility-weekly-hours-summary" },
            React.createElement(WeeklyHoursSummary, { totalDuration: totalDurationForWeek, workedDuration: workedDurationForWeek, scheduledDuration: scheduledDurationForWeek })),
        React.createElement(View, { dataTestId: "location-eligibility-card-list" },
            React.createElement(LocationEligibilityList, { siteEligibilities: siteEligibilitiesForWeek, fromHome: fromHome }))));
};
var HeaderContainer = styledWithTheme(Text)(function (_a) {
    var selectors = _a.theme.selectors;
    return "\n        background-color: ".concat(selectors.color('neutral0'), ";\n    ");
});
var PageTitle = styledWithTheme(Text)(function (_a) {
    var selectors = _a.theme.selectors;
    return "\n        color: ".concat(selectors.color('neutral100'), ";\n        font-size: ").concat(selectors.fontSize('T300'), ";\n        font-weight: ").concat(selectors.fontWeight('medium'), ";\n        line-height: ").concat(selectors.lineHeight('T300'), ";\n    ");
});
